import { Dispatch } from 'redux';

export const TASK_ACTIONS = {
  GET_TASKS: 'GET_TASKS',
  GET_TASKS_BY_ID: 'GET_TASKS_BY_ID',
  UPDATE_TASK: 'UPDATE_TASK',
  GET_SCHEDULED_TASK: 'GET_SCHEDULED_TASK',
  UPDATE_SCHEDULED_TASK: 'UPDATE_SCHEDULED_TASK',
  SCHEDULED_TASKS_BY_ID: 'SCHEDULED_TASKS_BY_ID',
  GET_LOGS: 'GET_LOGS',
  RUN_SCHEDULED_TASK: 'RUN_SCHEDULED_TASK',
  SCHEDULED_TASKS_BY_CLIENT_ID: 'SCHEDULED_TASKS_BY_CLIENT_ID',
  EXECUTION_LOG: 'EXECUTION_LOG',
  CREATE_SCHEDULED_TASK_DATA: 'CREATE_SCHEDULED_TASK_DATA',
  CREATE_SCHEDULED_TASK: 'CREATE_SCHEDULED_TASK',
};

export const ACTIONS = {
  IS_LOADING: 'IS_LOADING',
  API_ERROR: 'API_ERROR',
};

export const EXECUTION_LOG_TASKS = {
  GET_EXECUTION_LOG: 'GET_EXECUTION_LOG',
  SET_SELECTED_LOG: 'SET_SELECTED_LOG',
  SET_LOG_DATA: 'SET_LOG_DATA',
};

export const CLIENTS_ACTIONS = {
  ALL_CLIENTS: 'ALL_CLIENTS',
  UPDATE_CLIENT: 'UPDATE_CLIENT',
  ADD_CLIENT: 'ADD_CLIENT',
  UI_MODULES: 'UI_MODULES',
  USERS_BY_CLIENT: 'USERS_BY_CLIENT',
  CREDENTIALS_BY_CLIENT: 'CREDENTIALS_BY_CLIENT',
  CREATE_ENTRATA_CREDENTIALS: 'CREATE_ENTRATA_CREDENTIALS',
  UPDATE_ENTRATA_CREDENTIALS: 'UPDATE_ENTRATA_CREDENTIALS',
  CREATE_YARDI_SIPP_CREDENTIALS: 'CREATE_YARDI_SIPP_CREDENTIALS',
  UPDATE_YARDI_SIPP_CREDENTIALS: 'UPDATE_YARDI_SIPP_CREDENTIALS',
  SET_EDIT_CLIENT: 'SET_EDIT_CLIENT',
  SET_EDIT_USER: 'SET_EDIT_USER',
  UPDATE_USER: 'UPDATE_USER',
  ADD_USER: 'ADD_USER',
  SYSTEM_SETTINGS: 'SYSTEM_SETTINGS',
  UPDATE_SYSTEM_SETTINGS: 'UPDATE_SYSTEM_SETTINGS',
  SET_EDIT_SETTING: 'SET_EDIT_SETTING',
  CLIENT_PROPERTIES: 'CLIENT_PROPERTIES',
  GET_CLIENT_GROUP_OPTIONS: 'GET_CLIENT_GROUP_OPTIONS',
  GET_CLIENT_GROUP_LIST: 'GET_CLIENT_GROUP_LIST',
  GET_CLIENT_USER_LIST: 'GET_CLIENT_USER_LIST',
  ADD_CLIENT_GROUP: 'ADD_CLIENT_GROUP',
  REMOVE_CLIENT_FROM_GROUP: 'REMOVE_CLIENT_FROM_GROUP',
  EDIT_CLIENT_GROUP: 'EDIT_CLIENT_GROUP',
  EXISTING_CLIENT_GROUP: 'EXISTING_CLIENT_GROUP',
  ADD_USER_TO_GROUP: 'ADD_USER_TO_GROUP',
  GROUP_USERS_BY_CLIENT: 'GROUP_USERS_BY_CLIENT',
  REMOVE_USER_FROM_GROUP: 'REMOVE_USER_FROM_GROUP',
  SET_EDIT_PROPERTY_SETTING: 'SET_EDIT_PROPERTY_SETTING',
  UPDATE_PROPERTY_SETTINGS: 'UPDATE_PROPERTY_SETTINGS',
  PROPERTY_SETTINGS: 'PROPERTY_SETTINGS',
  RESET_PROPERTY_SETTINGS: 'RESET_PROPERTY_SETTINGS',
  CREATE_SFTP_CREDENTIALS: 'CREATE_SFTP_CREDENTIALS',
  UPDATE_SFTP_CREDENTIALS: 'UPDATE_SFTP_CREDENTIALS',
};
export const AUTH_ACTIONS = {
  SET_AUTH: 'SE_AUTH',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  SET_PROFILE: 'SET_PROFILE',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT: 'LOGOUT',
  LOADING: 'LOADING',
  UPDATE_TIMEZONE: 'UPDATE_TIMEZONE',
};

export const NOTIFICATION_ACTIONS = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
};

export const callWithLoader = (promise: any, dispatch: Dispatch) => {
  dispatch({
    type: ACTIONS.IS_LOADING,
    payload: true,
  });
  return promise.finally(() => {
    dispatch({
      type: ACTIONS.IS_LOADING,
      payload: false,
    });
  });
};

export const handleError = (dispatch, err) => {
  if (err.response.status === 401) {
    dispatch({
      type: AUTH_ACTIONS.LOGOUT,
    });
  } else {
    dispatch({
      type: ACTIONS.API_ERROR,
      payload: JSON.stringify(err.response.data),
    });
  }
};
